module.exports = __webpack_public_path__ + "static/img/49626.9aa0056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/49626.jpg
// module id = Sp/K
// module chunks = 1